// Action Types
export const ACTIVE_INDEX = 'ACTIVE_INDEX';
export const PATIENT_ID = 'PATIENT_ID';
export const REQUEST_ID = 'REQUEST_ID';
export const UPCOMING_ID = 'UPCOMING_ID';
export const PENDING_ID = 'PENDING_ID';
export const SELECT_PLAN = 'SELECT_PLAN';

// This action will simply save the details to Redux without any API call
export const basicDetailsValue = (type, details) => {
  switch (type) {
    case ACTIVE_INDEX:
      return {
        type: ACTIVE_INDEX,
        payload: details,
      };
    case PATIENT_ID:
      return {
        type: PATIENT_ID,
        payload: details,
      };
    case REQUEST_ID:
      return {
        type: REQUEST_ID,
        payload: details,
      };
    case UPCOMING_ID:
      return {
        type: UPCOMING_ID,
        payload: details,
      };
    case PENDING_ID:
      return {
        type: PENDING_ID,
        payload: details,
      };
    case SELECT_PLAN:
      return {
        type: SELECT_PLAN,
        payload: details,
      };
  }
};
